"use strict";

// Primary Navigation function
export default function Gallery() {

  var slider = tns({
    container: '.js-carousel',
    "items": 1,
    "autoplay": false,
    "speed": 500,
	 "arrowKeys": true,
	 "mouseDrag": true,
	 "lazyload": true,
    "controlsText": ['<i class="icon icon--arrow icon--arrow-left"></i>', '<i class="icon icon--arrow icon--arrow-right"></i>']
  });

};